import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

const EmailBanner: React.FC = () => {
  const [email, setEmail] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const alreadySignedUp = localStorage.getItem("email_signed_up");
    if (!alreadySignedUp) {
      setVisible(true);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const { error } = await supabase.from("email_subscribers").insert({ email });

    if (error) {
      alert("אירעה שגיאה. נסה שוב.");
      console.error(error);
      return;
    }

    localStorage.setItem("email_signed_up", "true");
    alert("תודה! נרשמת בהצלחה.");
    setVisible(false);
  };

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.content}>
        <span>הצטרפו לרשימת התפוצה שלנו!</span>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="email"
            placeholder="כתובת אימייל"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
          <button type="submit" style={styles.button}>שליחה</button>
        </form>
        <button onClick={handleClose} style={styles.close}>×</button>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  banner: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: "#f0f0f0",
    borderBottom: "1px solid #ccc",
    padding: "10px 20px",
    zIndex: 999,
    display: "flex",
    justifyContent: "center",
    fontFamily: "sans-serif",
  },
  content: {
    maxWidth: "800px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    direction: "rtl",
    position: "relative",
  },
  form: {
    display: "flex",
    gap: "8px",
    flex: 1,
  },
  input: {
    padding: "8px",
    flex: 1,
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  button: {
    padding: "8px 12px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  close: {
    position: "absolute",
    left: 0,
    top: 0,
    background: "transparent",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
  },
};

export default EmailBanner;
